function TessaraLogo(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <img {...props} src="./svg/login/tessara.svg" alt="Tessara Logo" />;
}

export default TessaraLogo;
